import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

//Layouts
import { FullLayoutComponent } from "./layouts/full-layout.component";

// Authentication
import { LoginComponent } from "./login/index";
import { AuthGuard } from "./_guards/index";

// Landingpage
import { ServiceCalculatorComponent } from "./landingpages/servicecalculator/index";
import { ServiceCheckoutComponent } from "./landingpages/servicecheckout/index";
import { DealerPageComponent } from "./landingpages/dealerpage/index";
import { ProlongingsDealerPageComponent } from "./landingpages/prolongings/dealerpage/index";
import { UsedCarsDealerPageComponent } from "./landingpages/usedcars/dealerpage/index";
import { DealerServiceCalculatorComponent } from "./landingpages/dealerservicecalculator/index";
import { DealerServiceCheckoutComponent } from "./landingpages/dealerservicecheckout/index";
import { UserPermissionComponent } from "./landingpages/userpermission/index";
import { DormantfeedbackComponent } from "./landingpages/dormantfeedback/dormantfeedback.component";
import { CarworkshopdncComponent } from "./landingpages/carworkshopdnc/carworkshopdnc.component";
import { AgreementAcceptanceComponent } from "./landingpages/agreementacceptance/agreementacceptance.component";
import { TyreInfoComponent } from "./landingpages/tyreinfo";
import { TyreHotelCheckoutComponent } from "./landingpages/tyrehotelcheckout";
import { CustomerTyreSearchComponent } from "./landingpages/customertyresearch/customertyresearch.component";
import { UsedCarsCalculatorComponent } from "./landingpages/usedcars/oder-flow";
import { UsedCarsCheckoutComponent } from "./landingpages/usedcars/oder-flow/checkout.component";
import { UsedCarAdditionalProductsComponent } from "./landingpages/usedcars/oder-flow/additional-products.component";
import { ProlongingsCalculatorComponent } from "./landingpages/prolongings/order-flow/calculator.component";
import { ProlongingsCheckoutComponent } from "./landingpages/prolongings/order-flow/checkout.component";
import { ProlongingsAdditionalProductsComponent } from "./landingpages/prolongings/order-flow/additional-products.component";
import { KmCatchUpCalculatorComponent, KmCatchUpCheckoutComponent } from "./landingpages/kmCatchUp/order-flow";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    canActivate: [AuthGuard],
    component: FullLayoutComponent,
    data: {
      title: "Home",
    },
      children: [
      {
          path: "dashboard",
          loadChildren: "app/dashboard/dashboard.module#DashboardModule",
      },
      {
          path: "cars",
          loadChildren: "app/cars/cars.module#CarsModule",
      },
      {
          path: "used-cars",
          loadChildren: "app/cars/cars.module#CarsModule",
      },
      {
          path: "prolongings",
          loadChildren: "app/cars/cars.module#CarsModule",
      },
      {
        path: "service-intervals",
        loadChildren: "app/cars/cars.module#CarsModule",
      },
      {
        path: 'serviceaddons/:serviceArea',
        loadChildren: 'app/serviceaddons/serviceaddons.module#ServiceAddonsModule'
      },
      {
        path: "tyres",
        loadChildren: "app/tyres/tyres.module#TyresModule",
      },
      {
        path: "serviceaddons",
        loadChildren:
          "app/serviceaddons/serviceaddons.module#ServiceAddonsModule",
      },
      {
        path: "customers",
        loadChildren: "app/customers/customers.module#CustomersModule",
      },
      {
        path: "dealers",
        loadChildren: "app/dealers/dealers.module#DealersModule",
      },
      {
        path: "useradmin",
        loadChildren: "app/useradmin/useradmin.module#UserAdminModule",
      },
      {
        path: "pdfcontracts",
        loadChildren: "app/pdfcontracts/pdfcontracts.module#PdfcontractsModule",
      },
      {
        path: "serviceagreements",
        loadChildren:
        "app/serviceagreements/serviceagreements.module#ServiceagreementsModule",
      },
      {
        path: "used-carsagreements/:serviceArea",
        loadChildren:
        "app/serviceagreements/serviceagreements.module#ServiceagreementsModule",
      },
      {
        path: "prolongingsagreements/:serviceArea",
        loadChildren:
        "app/serviceagreements/serviceagreements.module#ServiceagreementsModule",
      },
      {
        path: "userpermissions",
        loadChildren:
        "app/userpermissions/userpermissions.module#UserPermissionsModule",
      },
      {
        path: "dormantfeedbacks",
        loadChildren:
        "app/dormantfeedbacks/dormantfeedbacks.module#DormantFeedbacksModule",
      },
      {
        path: "leads",
        loadChildren: "app/leads/leads.module#LeadsModule",
      },
      {
        path: "used-cars-customers",
        loadChildren:
        "app/usedcars/customers/customers.module#UsedCarsCustomersModel",
      },
      {
        path: "prolongings-customers",
        loadChildren:
        "app/prolongings/customers/customers.module#ProlongingsCustomersModel",
      },
      {
        path: "customers-tyre",
        loadChildren:
        "app/tyrehotelcustomers/tyre-hotel-customers.module#TyreHotelCustomersModule",
      },
      {
        path: "service-intervals-customers",
        loadChildren:
        "app/serviceintervals/customers/customers.module#ServiceIntervalsCustomersModel",
      },
      {
        path: "service-intervals-matches",
        loadChildren:
        "app/serviceintervals/matches/matches.module#ServiceIntervalsMatchesModel",
      },
      {
        path: "monitor-km",
        loadChildren:
        "app/monitorkm/dashboard/monitorkm-dashboard.module#MonitorKmDashboardModule",
      },
      {
        path: "monitor-km/:id",
        loadChildren:
        "app/monitorkm/dashboard/monitorkm-dashboard.module#MonitorKmDashboardModule",
      },
      {
          path: 'pdfcontracts/:serviceArea',
          loadChildren: 'app/pdfcontracts/pdfcontracts.module#PdfcontractsModule'
      },
      {
        path: "tyres",
        loadChildren: "app/tyres/tyres.module#TyresModule",
      },
      {
        path: "tyre-templates/:dealer_id/:serviceArea",
        loadChildren: "app/pdfcontracts/pdfcontracts.module#PdfcontractsModule",
      },
      {
        path: "used-cars-templates/:dealer_id/:serviceArea",
        loadChildren: "app/pdfcontracts/pdfcontracts.module#PdfcontractsModule",
      },
      {
        path: "prolongings-templates/:dealer_id/:serviceArea",
        loadChildren: "app/pdfcontracts/pdfcontracts.module#PdfcontractsModule",
      },
      {
        path: "tyre-addons/:serviceArea",
        loadChildren:
        "app/serviceaddons/serviceaddons.module#ServiceAddonsModule",
      },
      {
        path: "used-cars-addons/:serviceArea",
        loadChildren:
        "app/serviceaddons/serviceaddons.module#ServiceAddonsModule",
      },
      {
        path: "prolongings-addons/:serviceArea",
        loadChildren:
        "app/serviceaddons/serviceaddons.module#ServiceAddonsModule",
      },
      {
        path: 'tyreagreements',
        loadChildren: 'app/tyreagreements/tyreagreements.module#TyreAgreementsModule'
      },
      {
        path: 'tyre-dashboard',
        loadChildren: 'app/tyredashboard/tyredashboard.module#TyreDashboardModule'
      },
      {
        path: 'tyre-templates/:dealer_id/:serviceArea',
        loadChildren: 'app/pdfcontracts/pdfcontracts.module#PdfcontractsModule'
      },
    ],
  },
  {
    path: "login",
    component: LoginComponent,
    data: {
      title: "Login",
    },
  },
  {
    path: "calculator",
    loadChildren: "app/landingpages/servicecalculator/servicecalculator.module#ServiceCalculatorModule"
  },
  {
    path: "tyreinfo",
    component: TyreInfoComponent,
  },
  {
    path: "checkout/:cust",
    loadChildren: "app/landingpages/servicecheckout/servicecheckout.module#ServiceCheckoutModule"
  },
  {
    path: "checkout/:id",
    loadChildren: "app/landingpages/servicecheckout/servicecheckout.module#ServiceCheckoutModule"
  },
  {
    path: "dealerpage/:id",
    component: DealerPageComponent,
  },
  {
    path: "prolongingsdealerpage/:id",
    component: ProlongingsDealerPageComponent,
  },
  {
    path: "usedcarsdealerpage/:id",
    component: UsedCarsDealerPageComponent,
  },
  {
    path: "dealercalculator",
    component: DealerServiceCalculatorComponent,
  },
  {
    path: "dealercheckout/:id",
    component: DealerServiceCheckoutComponent,
  },
  {
    path: "permission",
    component: UserPermissionComponent,
  },
  {
    path: "feedback",
    component: DormantfeedbackComponent,
  },
  {
    path: "carworkshopdnc",
    component: CarworkshopdncComponent,
  },
  {
    path: "agreement",
    component: AgreementAcceptanceComponent,
  },
  {
    path: "tyre-info/:id",
    component: TyreInfoComponent,
  },
  {
    path: "tyre-checkout",
    component: TyreHotelCheckoutComponent,
  },
  {
    path: "tyre-customer-search/:dealerId",
    component: CustomerTyreSearchComponent,
  },
  {
    path: "used-cars/order-flow/calculator",
    component: UsedCarsCalculatorComponent,
  },
  {
    path: "used-cars/order-flow/additional-products/:id",
    component: UsedCarAdditionalProductsComponent,
  },
  {
    path: "used-cars/order-flow/checkout/:id",
    component: UsedCarsCheckoutComponent,
  },
  {
    path: 'km-catch-up/order-flow/calculator/:id/:record',
    component: KmCatchUpCalculatorComponent,
  },
  {
    path: 'km-catch-up/order-flow/checkout/:id/:record',
    component: KmCatchUpCheckoutComponent,
  },
  {
    path: "prolongings/order-flow/calculator",
    component: ProlongingsCalculatorComponent,
  },
  {
    path: "prolongings/order-flow/checkout/:id",
    component: ProlongingsCheckoutComponent,
  },
  {
    path: "prolongings/order-flow/additional-products/:id",
    component: ProlongingsAdditionalProductsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts